<template>
  <div class="stil-kartice">
    <div class="odmik-v-kartici">
      <div class="stil-desnega-naslova">
        <a href="/Poraba/PorabaTelefonija" class="brez-stila">
          PREGLED PORABE
        </a>
        <span class="odmik-desne-zgoraj-ikone">
              <img src="/static/img/dashboard/Icon-material-unfold-more-grey.png">
            </span>
      </div>
      <div style="float: left">
        <div class=" icon-left">
          <p class="open-sans-20pt">
            Poraba telefonije
          </p>
        </div>
      </div>
      <div style="clear: both"/>
      <div style="padding-top: 10px">
        <el-select class="velikost-izbirnika-telefonija" v-model="izbranaFiksnaStevilka"
                   loading-text="Pregled Porabe"
                   placeholder="Izberite tel. številko">
          <el-option v-for="(data, key) in seznamFiksnihSt" :value="data.msisdn"
                     :label="VrniFormatiranoTelefonsko(data.msisdn, '1')"
                     :key="key">
          </el-option>
        </el-select>
      </div>
      <div style="padding-top: 30px;" v-if="porabaData !== null" v-loading="showLoader">
        <div class="row-poraba-telefonija">
          <div class="column-poraba-telefonija">
            <p class="open-sans-20pt mobilna-telefonija-postavitev-podatkov">
              {{ porabaData.skupnaKolicinaSekund }}
            </p>
            <p class="navadno-besedilo postavitev-podatkov-poraba">
              Trajanje klicev (v sekundah)
            </p>
          </div>
          <div class="column-poraba-telefonija">
            <p class="open-sans-20pt mobilna-telefonija-postavitev-podatkov">
              {{ porabaData.skupnaKolicinaZnesek }}
            </p>
            <p class="navadno-besedilo postavitev-podatkov-poraba">
              Znesek v € (z DDV)
            </p>
          </div>
        </div>
      </div>
      <div style="padding-top: 10px">
        <p>
            <span>
              <img src="/static/img/dashboard/Icon-awesome-info-circle.png" class="Icon-awesome-info-circle">
              <a class="info-box-poraba">
                Podatki za tekoče obračunsko obdobje.
              </a>
            </span>
        </p>
      </div>
    </div>
    <div style="clear: both"/>
  </div>
</template>

<script>
import {PorabaTelefonija} from '../../../../../assets/js/globalne_funkcije/PorabaTelefonija/PorabaTelefonija.js'
import {Select, Option} from 'element-ui'
import {FormatirajTelefonskoStevilko}
  from '../../../../../assets/js/globalne_funkcije/GlobalnoTelefonija/FormatTelefonskeStevilke.js'

export default {
  name: 'KarticaFiksnaPoraba',
  components: {
    [Select.name]: Select,
    [Option.name]: Option
  },
  mixins: [PorabaTelefonija, FormatirajTelefonskoStevilko],
  data () {
    return {
      showLoader: false,
      izbranaFiksnaStevilka: null,
      porabaData: null
    }
  },
  props: {
    seznamFiksnihSt: null,
    izbranSap: null,
    izbranaStevilka: null
  },
  methods: {
    PridobiPoraboStevilke (stevilka) {
      let param = {}
      param.vmesnik = this
      param.izbranaTelefonskaStevilka = stevilka
      param.callBackFunction = this.NastaviPoraba
      param.prenesenIzbranSap = this.izbranSap
      this.showLoader = true
      this.porabaData = null
      this.GetPorabaInfo(param)
    },
    NastaviPoraba (podatki) {
      this.porabaData = podatki
      this.showLoader = false
    }
  },
  watch: {
    izbranaStevilka: function (stevilka) {
      if (typeof stevilka !== 'undefined' && stevilka !== null) {
        this.izbranaFiksnaStevilka = stevilka
      }
    },
    izbranaFiksnaStevilka: function (stevilka) {
      this.PridobiPoraboStevilke(stevilka)
    }
  }
}
</script>

<style scoped src="../../../../../../static/css/Domov/naslovna-stran.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Poraba/Komponente/KarticaFiksnaPoraba.vue